import { Component, Input } from '@angular/core';

import { ConcatenatedFieldsPipe } from '../concatenated-fields.pipe';

@Component({
  selector: 'atx-concatenated-object-fields',
  imports: [ConcatenatedFieldsPipe],
  template: ` @if (sourceObject | concatenatedFields: { fields: sourceFields };
    as concatenatedText) {
    {{ concatenatedText }}
    }`,
})
export class ConcatenatedObjectFieldsComponent {
  @Input({ required: true }) public sourceObject = {};
  @Input() public sourceFields: string[] = [];
}
